import {IKnockoutComponent, ITranslationParams} from "../../index";

interface ISearchRowButtons {
    attr?: any
    fn?: (...args: any[]) => void
    href?: string | ((arg: any) => string)
    icon: string
    validator?: (...args: any[]) => boolean
    title?: string
    cls?: string
    getComponent?: (...args: any[]) => IKnockoutComponent
    enabled?: (...args: any[]) => boolean // only used if type is button (e.g. fn is defined)
}

interface ISearchPageButton {
    fn?: Function
    href?: string
    icon: string
    label: string | ITranslationParams
}
